export default "__VITE_ASSET__BFriK1n6__"